<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconUnlock_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M9.907 6.385V4.077c0-1.052.821-1.908 1.91-1.908s1.91.856 1.91 1.908v.461H15v-.461C15 2.378 13.574 1 11.817 1S8.634 2.378 8.634 4.077v2.308z"
    />
    <path
        fill="currentColor"
        d="M2.637 6.385A.626.626 0 0 0 2 7v7.385c0 .34.285.615.637.615h9.23a.626.626 0 0 0 .637-.615V7a.626.626 0 0 0-.637-.615z"
    />
</svg>
